export default "__VITE_ASSET__fc7xDEdm__"